import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography } from "@material-ui/core";
import { Route, BrowserRouter as Router } from "react-router-dom";

// Components
import Footer from "./elements/Footer";
import MainContainer from "./mainContainer/MainContainer";
import NavigationBar from "./navigationBar/NavigationBar";
import SystemContainer from "./containers/systemContainer/SystemContainer";

// Medias
import mena_fccg_logo from "../assets/images/mena-fccg-logo.svg";

// Styles
import AppStyle from "../assets/styles/materialUI/global/AppStyle";

// Icons
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import LanguageIcon from "@material-ui/icons/Language";

// Services
import auth from "../services/auth/auth";

// Providers
import { useLanguage } from "../contexts/languageContext";
import { UserInfoProvider } from "../contexts/userInfoContext";

function App() {
	const classes = AppStyle();
	const { t } = useTranslation();
	const { direction } = useLanguage();
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);

	if (error || message)
		return (
			<Grid className={`${classes.loaderContainer} justify-content-center`} dir={direction}>
				<Grid className={classes.loader}>
					<img src={mena_fccg_logo} width="300px" alt={t("common.appName") || "App logo"} />
				</Grid>
				<Grid className={classes.loader}>
					<Typography className={classes.typography}>{t("common.userSettingsUpdate")}</Typography>
				</Grid>
				<Grid className={`${classes.subLoaderContainer} justify-content-center`}>
					<Grid className={error ? classes.subLoaderError : classes.subLoaderMessage}>
						<LanguageIcon className={classes.infoIcon} />
					</Grid>
					{error && (
						<Grid className={classes.subLoaderError}>
							<Typography className={classes.errorMessage}>{t(error)}</Typography>
						</Grid>
					)}
					{message && (
						<Grid className={classes.subLoaderMessage}>
							<Typography className={classes.infoMessage}>{t(message)}</Typography>
						</Grid>
					)}
				</Grid>
			</Grid>
		);

	return (
		<>
			<UserInfoProvider>
				<SystemContainer>
					{auth.isActive() && (
						<Router>
							<div className={`fluid-container ${direction === "rtl" ? "rtl" : ""}`}>
								<div className={classes.header}>
									<Route
										path="/questionnaire"
										component={() => <NavigationBar setError={setError} setMessage={setMessage} />}
									/>
								</div>
								<div className={`${classes.body}`}>
									<MainContainer />
								</div>
							</div>
						</Router>
					)}
					{!auth.isActive() && (
						<Grid className={`${classes.loaderContainer} justify-content-center`}>
							<Grid className={classes.loader}>
								<img src={mena_fccg_logo} width="300px" alt={t("common.appName") || "App logo"} />
							</Grid>
							<Grid className={classes.loader}>
								<Typography className={classes.typography}>{t("common.loadingFailed")}</Typography>
							</Grid>
							<Grid className={`${classes.subLoaderContainer} justify-content-center`}>
								<Grid className={classes.subLoaderError}>
									<VpnKeyIcon className={classes.errorIcon} />
								</Grid>
								<Grid className={classes.subLoaderError}>
									<Typography className={classes.errorMessage}>
										{t("common.licenseExpired")}
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					)}
				</SystemContainer>
			</UserInfoProvider>
			<Footer />
		</>
	);
}

export default App;
